import { fork } from 'redux-saga/effects';
import { appSagas } from "../app/appSagas.js";
import { accountSagas } from "../modules/Account/accountSagas.js";
import { bonusesSagas } from "../modules/Bonus/bonusesSagas.js";
import { googleTagManagerSagas } from "../modules/GoogleTagManager/googleTagManagerSagas.js";
import { liteTradeSagas } from "../modules/LiteTrade/liteTradeSagas.js";
import { loginSagas } from "../modules/Login/loginSagas.js";
import { notificationsSagas } from "../modules/Notifications/notificationsSagas.js";
import { mobileAppSagas } from "./mobileAppSagas.js";

export function* mobileAppCoreSagas() {
    yield fork(accountSagas);
    yield fork(appSagas);
    yield fork(bonusesSagas);
    yield fork(googleTagManagerSagas);
    yield fork(liteTradeSagas);
    yield fork(loginSagas);
    yield fork(mobileAppSagas);
    yield fork(notificationsSagas);
}
